import { utcCalendarDate } from "./unitDefHoldover";

export const CANNON_CODEX_FROM = "2026-10-08";

export const REPAIR_RETREAT_AVOID_PRODUCTION_FROM = "2026-10-07";

export function isCannonCodexEnabled(atMs = Date.now()): boolean {
  return utcCalendarDate(atMs) >= CANNON_CODEX_FROM;
}

export function isRepairRetreatAvoidProductionEnabled(atMs = Date.now()): boolean {
  return utcCalendarDate(atMs) >= REPAIR_RETREAT_AVOID_PRODUCTION_FROM;
}
